import appConfig from 'config';
import * as types from '../actions/modal-actions';

const initialState = {
	show: false,
	size: "sm",
	closeButton: true,
	title: "",
	icon: "",
	description: "",
	buttons: []
};

const menuReducer = function (state = initialState, action) {
	switch (action.type) {
		case types.RESET_VALUES:
			return Object.assign({}, state, initialState, {
				show: true
			});
			break;

		case types.SHOW_MODAL:
			return Object.assign({}, initialState, action.modal, {
				show: true
			});
			break;

		case types.HIDE_MODAL:
			return Object.assign({}, state, {
				show: false
			});
			break;
	}

	return state;
};

export default menuReducer;



// WEBPACK FOOTER //
// ./src/reducers/modal-reducer.js